import React, { useEffect } from 'react';
import { Form, FieldArray, FormikProvider } from 'formik';
import AddHeader from '../../../../components/layout/header/add';
import Forms from '../../../../components/molecules/forms';
import { Delete, DollarSign } from '../../../../components/atoms/icons';
import Button from '../../../../components/molecules/buttons';
import useAddInvoice from './hooks';

function AddInvoice() {
  const { formik, addServiceInvoiceLoad, navigateToLanding } = useAddInvoice();
  /* eslint-disable */
  useEffect(() => {
    const laborHour = formik.values.laborHour;
    const laborRate = formik.values.laborRate;
    const discount = formik.values.discount;
    if (laborHour && !laborRate) {
      formik.setFieldValue('billAmount', laborHour);
    }
    if (!laborHour && laborRate) {
      formik.setFieldValue('billAmount', laborRate);
    }
    if (laborHour && laborRate) {
      formik.setFieldValue('billAmount', (laborHour * laborRate));
    }
    if (laborHour && laborRate && discount) {
      formik.setFieldValue('billAmount', (laborHour * laborRate) - discount);
    }
    if (!laborHour && !laborRate && !discount) {
      formik.setFieldValue('billAmount', 0);
    }
  }, [formik.values.laborHour, formik.values.laborRate, formik.values.discount]);

  return (
    <div>
      <AddHeader
        primary={{ route: '/customer-support', title: 'Service Request' }}
        title="Add Invoice"
      />
      <FormikProvider value={formik}>
        <Form>
          <FieldArray
            name="parts"
            render={(arrayHelpers) => (
              <div>
                <div className="px-4 px-xl-5">
                  <div className="row">
                    <div className="col-lg-4">
                      <Forms.ReactDatePicker
                        id="serviceDate"
                        selectedDate={formik.values.serviceDate}
                        handleChange={(x) => {
                          if (x) formik.setFieldValue('serviceDate', x);
                        }}
                        label="Schedule Date"
                        placeholder="Choose Schedule Date"
                        className="mb-4"
                      />
                    </div>
                    <div className="col-lg-4">
                      <Forms.DefaultWithIcon
                        id="laborHour"
                        placeholder="Enter no. of labour hour(s)"
                        label="Labour Hour(s)"
                        className="mb-4"
                        value={formik.values.laborHour}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.laborHour && formik.touched.laborHour}
                        errorMsg={formik.errors.laborHour}
                        type="number"
                      />
                    </div>
                    <div className="col-lg-4">
                      <Forms.DefaultWithIcon
                        id="laborRate"
                        placeholder="Enter Labour Rate"
                        label="Labor Rate / hour"
                        leftIcon={<DollarSign />}
                        className="mb-4"
                        value={formik.values.laborRate}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.laborRate && formik.touched.laborRate}
                        errorMsg={formik.errors.laborRate}
                        type="number"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <Forms.DefaultWithIcon
                        id="billAmount"
                        placeholder="Enter Bill Amount"
                        label="Bill Amount"
                        leftIcon={<DollarSign />}
                        className="mb-4"
                        value={formik.values.billAmount}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.billAmount && formik.touched.billAmount}
                        errorMsg={formik.errors.billAmount}
                        type="number"
                      />
                    </div>
                    <div className="col-lg-4">
                      <Forms.DefaultWithIcon
                        id="discount"
                        placeholder="Enter Discount"
                        label="Discount (Optional)"
                        leftIcon={<DollarSign />}
                        className="mb-4"
                        value={formik.values.discount}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        isInvalid={!!formik.errors.discount && formik.touched.discount}
                        errorMsg={formik.errors.discount}
                        type="number"
                      />
                    </div>
                  </div>
                  <Forms.Default
                    id="description"
                    placeholder="Enter Description"
                    as="textarea"
                    label="Description"
                    rows={4}
                    className="mb-4"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={!!formik.errors.description && formik.touched.description}
                    errorMsg={formik.errors.description}
                  />
                </div>
                <div className="bg-stroke mt-5 mb-4" style={{ height: '7px' }} />
                <div className="px-4 px-xl-5">
                  <div className="fw-bold fz-16 mb-4">Add Parts</div>
                  {formik.values.parts.map((part, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="row" key={i}>
                      <div className="col-lg-4">
                        <Forms.Default
                          id={`parts[${i}].name`}
                          placeholder="Enter Part Name"
                          label="Part Name"
                          className="mb-4"
                          value={formik.values.parts[i].name}
                          onChange={formik.handleChange}
                          // @ts-ignore
                          isInvalid={!!formik.errors.parts?.[i]?.name && formik.touched.parts?.[i]?.name}
                          // @ts-ignore
                          errorMsg={formik.errors.parts?.[i]?.name}
                        />
                      </div>
                      <div className="col-lg-4">
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <Forms.DefaultWithIcon
                              id={`parts[${i}].price`}
                              placeholder="Enter Part Price"
                              label="Part Price"
                              className="mb-4"
                              value={formik.values.parts[i].price}
                              onChange={formik.handleChange}
                              type="number"
                              leftIcon={<DollarSign />}
                              // @ts-ignore
                              isInvalid={!!formik.errors.parts?.[i]?.price && formik.touched.parts?.[i]?.price}
                              // @ts-ignore
                              errorMsg={formik.errors.parts?.[i]?.price}
                            />
                          </div>
                          <button
                            type="button"
                            className="border-0 rounded-circle bg-stroke flexible-center ms-2 mt-1"
                            style={{ height: 40, width: 40 }}
                            onClick={() => arrayHelpers.remove(i)}
                          >
                            <Delete color="black" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="fz-14 fw-bold color-primary bg-transparent border-0"
                    onClick={() => arrayHelpers.push({ price: 0, name: '' })}
                  >
                    +Add Another Part
                  </button>
                </div>
                <div className="bg-stroke mt-5 mb-4" style={{ height: '7px' }} />
                <div className="d-flex justify-content-end p-4 px-xl-5">
                  <div style={{ width: '200px', marginRight: '20px' }}>
                    <Button.Default
                      id="cancel"
                      type="button"
                      label="Cancel"
                      size="lg"
                      onClick={navigateToLanding}
                      outline
                    />
                  </div>
                  <div style={{ width: '200px' }}>
                    <Button.Default
                      id="submit"
                      type="submit"
                      label="Generate"
                      size="lg"
                      loading={addServiceInvoiceLoad}
                    />
                  </div>
                </div>
              </div>
            )}
          />
        </Form>
      </FormikProvider>
    </div>
  );
}

export default AddInvoice;
